module.exports = __webpack_public_path__ + "img/gif.c4ad78c4.png";